import { keymap } from "prosemirror-keymap";
import { Extension } from "../../core/extension";
import { bindCommandToKey, toggleMark } from "../../commands/commands";
import { italicMarkSpec } from "./schema";
export class ItalicExtension extends Extension {
    addMarks(marks) {
        return marks.append(italicMarkSpec());
    }
    addCommands(schema) {
        return {
            toggleItalic: toggleMark(schema.marks.em),
        };
    }
    addPlugins(schema, plugins, { commands }) {
        return plugins.concat([
            keymap({
                "Mod-i": bindCommandToKey(commands.toggleItalic),
            }),
        ]);
    }
}
